import axios from 'axios';

export const FilmAnalysisAndRepairReportService = {
  getTitleName: () => axios.get(`/PcProcess/getTitleName`),
  getTitleNameCount: (title: string) =>
    axios.get(`/PcProcess/getTitleNameCount?titleName=${title}`),
  finalAnalysisRepairReports: (title: string) =>
    axios.get(`/PcProcess/finalAnalysisRepairReports?titleName=${title}`),
};
